/* This component is a child of PricingPlans and sibling of monthly.js. This component imports the Tabs component which displays the tab labels, and the active * tab content for the monthly pricing selection. This component will need to import basic-features, mid-features and premium-features.js and those components
 * will live within the cooresponding divs below in order to be displayed wihtin each tab's content. Tabs is a child of the monthly and annual pricing
 * components.
 * the "label" tags in the divs is IMPORTANT. Do not remove the tabs and tab components won't know which tab is active or what label to display
 */

import React from 'react';
import Tabs from './tabs';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import './styles.css';
import PricingPageStyle from './pricing-page.module.scss';

const AnnualPricingMobile = () => (
  <StaticQuery
    query={graphql`
      query AnnualPricingMobile {
        contentfulPricingPlansAssemblyPage {
          basicAnnualPricing {
            annualSetupFee
            annualSupportFee
            activeFeatures {
              json
            }
            inactiveFeatures {
              json
            }
            addOnFeatures {
              json
            }
            activeSupport {
              json
            }
            inactiveSupport {
              json
            }
          }
          midLevelAnnualPricing {
            annualSetupFee
            annualSupportFee
            activeFeatures {
              json
            }
            inactiveFeatures {
              json
            }
            addOnFeatures {
              json
            }
            activeSupport {
              json
            }
          }
          premiumAnnualPricing {
            annualSetupFee
            annualSupportFee
            activeFeatures {
              json
            }
            inactiveFeatures {
              json
            }
            addOnFeatures {
              json
            }
            activeSupport {
              json
            }
            inactiveSupport {
              json
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className={PricingPageStyle.annualPricing}>
        <Tabs>
          <div label='Starter'>
            {/* Basic Pricing */}
            <h3 className={PricingPageStyle.basicPlanTitleMobile}>Starter</h3>
            <h4 className={PricingPageStyle.pricingPlanMthlyPrice}>
              {
                data.contentfulPricingPlansAssemblyPage.basicAnnualPricing
                  .annualSupportFee
              }
            </h4>
            <p className={PricingPageStyle.annualSetupFee}>
              {
                data.contentfulPricingPlansAssemblyPage.basicAnnualPricing
                  .annualSetupFee
              }
            </p>
            {/* Starter Checkout */}
            <a
              href='https://app.firststringdigital.com/starter-annual'
              className={PricingPageStyle.choosePlanBtn1}
            >
              Let's Get Started
            </a>

            {/* Basic Active Features */}
            <div className={PricingPageStyle.activeFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicAnnualPricing
                  .activeFeatures.json
              )}
            </div>

            {/* Basic Inactive Features -- None exist at this tme --  */}
            <div
              className={`${PricingPageStyle.basicInactiveFeaturesDiv} ${PricingPageStyle.inactiveFeaturesDiv}`}
            >
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicAnnualPricing
                  .inactiveFeatures.json
              )}
            </div>

            <hr />

            {/* Basic Active Ongoing Support */}
            <div className={PricingPageStyle.activeSupportDiv}>
              <h4>Ongoing Support</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicAnnualPricing
                  .activeSupport.json
              )}
            </div>

            {/* Basic Inactive Ongoing Support */}
            <div className={PricingPageStyle.inactiveSupportDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicAnnualPricing
                  .inactiveSupport.json
              )}
            </div>

            <hr />

            {/* Basic Add-on Features */}
            <div className={PricingPageStyle.addonFeaturesDiv}>
              <h4>Add-on Features</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicAnnualPricing
                  .addOnFeatures.json
              )}
            </div>

            {/* Starter Checkout */}
            <a
              href='https://app.firststringdigital.com/starter-annual'
              className={PricingPageStyle.choosePlanBtn1}
            >
              Let's Get Started
            </a>
          </div>
          <div label='Entree'>
            {/* Midlevel Pricing */}
            <h3 className={PricingPageStyle.midLevelPlanTitleMobile}>Entree</h3>
            <h4 className={PricingPageStyle.pricingPlanMthlyPrice}>
              {
                data.contentfulPricingPlansAssemblyPage.midLevelAnnualPricing
                  .annualSupportFee
              }
            </h4>
            <p className={PricingPageStyle.annualSetupFee}>
              {
                data.contentfulPricingPlansAssemblyPage.midLevelAnnualPricing
                  .annualSetupFee
              }
            </p>
            {/* Entree Checkout */}
            <a
              href='https://app.firststringdigital.com/entree-annual'
              className={PricingPageStyle.choosePlanBtn2}
            >
              Let's Get Started
            </a>

            {/* MidLevel Active Features */}
            <div className={PricingPageStyle.activeFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelAnnualPricing
                  .activeFeatures.json
              )}
            </div>
            {/* MidLevel Inactive Features -- None at this time --  */}
            <div
              className={`${PricingPageStyle.midLevelInactiveFeaturesDiv} ${PricingPageStyle.inactiveFeaturesDiv}`}
            >
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelAnnualPricing
                  .inactiveFeatures.json
              )}
            </div>

            <hr />

            {/* MidLevel Active Ongoing Support */}
            <div className={PricingPageStyle.activeSupportDiv}>
              <h4>Ongoing Support</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelAnnualPricing
                  .activeSupport.json
              )}
            </div>

            {/* MidLevel Inactive Ongoing Support */}
            {/* <div className={PricingPageStyle.inactiveSupportDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelAnnualPricing
                  .inactiveSupport.json
              )}
            </div> */}

            <hr />

            {/* Midlevel Add-on Features */}
            <div
              className={`${PricingPageStyle.midLevelAddonFeaturesDiv} ${PricingPageStyle.addonFeaturesDiv}`}
            >
              <h4>Add-on Features</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelAnnualPricing
                  .addOnFeatures.json
              )}
            </div>

            {/* Entree Checkout */}
            <a
              href='https://app.firststringdigital.com/entree-annual'
              className={PricingPageStyle.choosePlanBtn2}
            >
              Let's Get Started
            </a>
          </div>
          <div label='Dessert'>
            {/* Premium Level Pricing */}
            <h3 className={PricingPageStyle.premiumPlanTitleMobile}>Dessert</h3>
            <h4 className={PricingPageStyle.pricingPlanMthlyPrice}>
              {
                data.contentfulPricingPlansAssemblyPage.premiumAnnualPricing
                  .annualSupportFee
              }
            </h4>
            <p className={PricingPageStyle.annualSetupFee}>
              {
                data.contentfulPricingPlansAssemblyPage.premiumAnnualPricing
                  .annualSetupFee
              }
            </p>
            {/* Dessert Checkout */}
            <a
              href='https://app.firststringdigital.com/dessert-annual'
              className={PricingPageStyle.choosePlanBtn3}
            >
              Let's Get Started
            </a>

            {/* Premium Active Features */}
            <div className={PricingPageStyle.activeFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumAnnualPricing
                  .activeFeatures.json
              )}
            </div>

            {/* Premium Inactive Features */}
            <div
              className={`${PricingPageStyle.premiumInactiveFeaturesDiv} ${PricingPageStyle.inactiveFeaturesDiv}`}
            >
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumAnnualPricing
                  .inactiveFeatures.json
              )}
            </div>

            <hr />

            {/* Premium Active Ongoing Support */}
            <div className={PricingPageStyle.activeSupportDiv}>
              <h4>Ongoing Support</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumAnnualPricing
                  .activeSupport.json
              )}
            </div>

            <hr />

            {/* Premium Add-on Features */}
            <div
              className={`${PricingPageStyle.premiumAddonFeaturesDiv} ${PricingPageStyle.addonFeaturesDiv}`}
            >
              <h4>Add-on Features</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumAnnualPricing
                  .addOnFeatures.json
              )}
            </div>

            {/* Dessert Checkout */}
            <a
              href='https://app.firststringdigital.com/dessert-annual'
              className={PricingPageStyle.choosePlanBtn3}
            >
              Let's Get Started
            </a>
          </div>
        </Tabs>
      </div>
    )}
  />
);

export default AnnualPricingMobile;
